import { TextExtractionBlock } from '../../../types';
import { HtmlBuilder } from './html-builder-interface';

export const textHtmlBuilder: HtmlBuilder<TextExtractionBlock> = (block) => {
  return `<p id="p${block.numero}">${block.texto}</p>`;
};
